




























































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































/* eslint-disable no-console */
import { Component, Vue, Ref } from 'vue-property-decorator';
import SLoader from '@/components/UI/Loader/SLoader.vue';
import gql from 'graphql-tag';
import { IRules } from '@/components/UI/Form/ValidationModule';
import { validateRequired, validateMin, validateMax } from '@/components/UI/Form/Validations';

@Component
export default class UiTest extends Vue {
  @Ref() public readonly loaderRef!: HTMLElement;
  public input = 12312;
  public input2 = -12345.27999;
  public disabled = false;
  public checked = false;
  public selectedRadio = 'test1';
  public selectedRadio2 = 'test1';
  public selectedOption = 'value1';
  public autocompleteInput = 'test5';
  public autocompleteInput2 = 10;
  public datepicker = '2019-08-02';
  public loaderShow = true;
  public loaderShowNew = true;
  public loader: SLoader | null = null;
  public upload = null;
  public isLoading = false;
  public data = [
    { id: 10, name: 'test5', description: 'testing', unit: { name: 'testUnit' } },
    { id: 1, name: 'test1' },
    { id: 12, name: 'test3', unit: { test: 1, name: 'testtest' } },
    { id: 2, name: 'abc35', description: 'testing2', unit: { test: 1 } },
    { id: 3, name: 'abc1 long text that will stretch the td', description: 'testing2', unit: { test: 1 } },
  ];
  public formRules: IRules = {
    name: [
      { validation: validateRequired(), message: 'Test invalid' },
      { validation: validateMin(3), message: 'Min test' },
      { validation: validateMax(5), message: 'Max test' },
    ],
    description: [ { validation: validateRequired() } ],
    isCar: [ { validation: validateRequired(), message: 'Required' } ],
    checked: [ { validation: validateRequired(), message: 'Test message' } ],
    file: [
      { validation: validateRequired(), message: 'Please add some files' },
      { validation: validateMin(3), message: 'Please upload at least 3 files' },
      { validation: validateMax(4), message: 'Please upload up to 4 files' },
      {
        validation: ({ dataValue }) => {
          if (!dataValue) return true;
          const filetypes = [ 'image/jpeg', 'image/png', 'image/tiff', 'application/pdf' ];
          const files = dataValue instanceof File ? [ dataValue ] : dataValue as File[];
          return Array.from(files).every(file => filetypes.includes(file.type));
        },
        message: 'Please upload a valid file type',
      },
    ],
  };
  public form: {
    name: string;
    description: string;
    isCar: boolean;
    checked: boolean;
    file: File | undefined;
  } = {
    name: '',
    description: '',
    isCar: false,
    checked: false,
    file: undefined,
  };

  private signedNumber = 5;
  private signedNumberPositive = true;

  public get logoUpload() {
    return { file: this.form.file };
  }

  public query = gql`
    mutation($file: FileUpload!) {
      updateUnitSetting(input: {unitSetting: {id: 1, logo: $file}}) {
        unitSetting { id logo { url(size: ICON) } }
      }
    }
  `;

  public openPopup = false;
  public secondOpenPopup = false;

  public input1 = '';

  public options = [ 'test', 'test2', 'test3', 'test4', 'test5' ];

  public disabledOptions = false;

  public selectedMultipleOption = [ 'value1', 'value2' ];

  public counter = 10;

  public addToCounter() {
    this.counter += 50;
  }

  public removeOption() {
    this.options.pop();
  }

  public triggerPopupAlert() {
    this.$sPopup.alert('testing', {
      buttons: [
        {
          text: 'Yeah',
          color: 'success',
          click: () => console.log('boiiii'),
        },
        {
          text: 'Click Me',
          click: () => console.log('clicked'),
        },
      ],
      onConfirm: () => '',
      onCancel: () => console.log('canceled'),
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public filterByAutocomplete(item: any) {
    return item.name;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public valueByAutocomplete(item: any) {
    return item.id;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public filterFunctionAutocomplete(source: any[], term: string) {
    return source
      .filter(el => el.name.toLowerCase().startsWith(term.toLowerCase()));
  }

  public handleEmptyAutocomplete() {
    this.$sMessage('autocomplete is empty', { duration: 1000 });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public handleSelectAutocomplete(item: any) {
    this.$sMessage(`item ${JSON.stringify(item)} is selected`, { duration: 0 });
  }

  public openNewPopup() {
    this.$sPopup.confirm(`Delete`, {
      onConfirm: () => console.log('confirm'),
      title: 'qwe',
    });
  }

  public secondClosePopup() {
    this.secondOpenPopup = false;
  }

  public closePopup() {
    this.openPopup = false;
  }

  public openMessage() {
    this.isLoading = true;
    setTimeout(() => { this.isLoading = false }, 1500);
    this.$sMessage.info('Info');
    this.$sMessage.warning('Closes after 3s');
    this.$sMessage.error('closes after 1s', { duration: 1000 });
    this.$sMessage.success('Stays open, have custom title', { duration: 0, title: 'Titled success' });
  }

  public onChange(event: {target: HTMLInputElement}) {
    const value = event.target.value;
    console.log('it changes', value, typeof value);
  }

  public onFocus(event: FocusEvent) {
    console.log('it focus', event, typeof event);
  }

  public onBlur(event: FocusEvent) {
    console.log('it blurs', event, typeof event);
  }

  public startLoader() {
    if (this.loader) {
      this.loader.show = !this.loader.show;
    } else {
      this.loader = this.$sLoader({
        show: this.loaderShow,
        element: this.loaderRef,
      });
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public delayed1(e: any) {
    console.log('delayed1', e, this);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public delayed2(e: any) {
    console.log('delayed2', e, this);
  }

  public delayed3(val: string) {
    console.log('delayed3', val, this);
  }
}
